/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Titles_Lastactivityformatted2Inputs */

const en_titles_lastactivityformatted2 = /** @type {(inputs: Titles_Lastactivityformatted2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last activity: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last activity: {date}" |
*
* @param {Titles_Lastactivityformatted2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_lastactivityformatted2 = /** @type {((inputs: Titles_Lastactivityformatted2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Lastactivityformatted2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_lastactivityformatted2(inputs)
});
export { titles_lastactivityformatted2 as "titles_lastActivityFormatted" }